import httpService from '@Utils/httpService';

const baseUrl = 'api';

export default {
    getPreferences() {
        return httpService.get({
            url: `${baseUrl}/NotificationsPreferences`
        });
    },
    updatePreferences(data) {
        return httpService.put({
            url: `${baseUrl}/NotificationsPreferences`,
            data,
        });
    },
    getUserNotifications(params) {
        return httpService.get({
            url: `${baseUrl}/UserNotifications`,
            params,
        });
    },
    read(data) {
        return httpService.put({
            url: `${baseUrl}/UserNotifications/${data.id}/read?value=${data.value}`
        });
    },
    readAll() {
        return httpService.put({
            url: `${baseUrl}/UserNotifications/read-all`
        });
    },
    clearAll() {
        return httpService.delete({
            url: `${baseUrl}/UserNotifications/clear-all`
        });
    }
};
